

































import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {}
})
export default class KeadaanUmum extends Vue {
  @Prop() setKu!: string;
  @Prop() setLabel!: string;
  // ku = "";
  label = "";
  placeholder = this.setLabel;

  mounted() {
    if (this.setLabel == "") {
      this.label = "";
      this.placeholder = "";
    } else {
      if (this.setKu == "" || this.setKu == null) {
        this.label = "";
        this.placeholder = this.setLabel;
      } else {
        this.label = this.setLabel;
        this.placeholder = "";
      }
    }
  }
  // @Watch("ku")
  // changeku(val) {
  //   if (this.setLabel == "") {
  //     this.label = "";
  //     this.placeholder = "";
  //   } else {
  //     if (val == "" || val == null) {
  //       this.label = "";
  //       this.placeholder = this.setLabel;
  //     } else {
  //       this.label = this.setLabel;
  //       this.placeholder = "";
  //     }
  //   }
  //   this.$emit("ku", val);
  // }

  @Watch("setKu")
  valku(val) {
    if (this.setLabel == "") {
      this.label = "";
      this.placeholder = "";
    } else {
      if (val == "" || val == null) {
        this.label = "";
        this.placeholder = this.setLabel;
      } else {
        this.label = this.setLabel;
        this.placeholder = "";
      }
    }
    this.$emit("ku", val);
    this.setKu = val;
  }
}
